import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useRelease150 } from "../../lib/release150";

/** Release 1.5.0 (O-R64): the logo opens the person's start page. Off: the 1.4.0 logo, not a link. */
export function HomeLogoLink({ children }: { children: ReactNode }) {
  const on = useRelease150();
  if (!on) return <>{children}</>;
  return (
    <Link to="/" aria-label="Summit Operations — open your start page" className="block rounded-md outline-none focus-visible:ring-2 focus-visible:ring-white/70" data-testid="logo-home-link">
      {children}
    </Link>
  );
}
